export function sortCertifications(a, b) {
  return a.rank > b.rank ? 1 : -1;
}
